/* FUKUI theme — global JS
   Header (mega menus, mobile drawer), announcement marquee, 井 grid toggle,
   toast, and the AJAX cart drawer wired to Shopify's Cart API. */
(function () {
  'use strict';

  var FUKUI = window.FUKUI = window.FUKUI || {};

  /* ── money ─────────────────────────────────── */
  FUKUI.formatMoney = function (cents) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    /* multi-currency: cart amounts arrive in the buyer's presentment
       currency, so the shop's € template would mislabel them — format by
       the actual cart currency instead, falling back to the template */
    if (FUKUI.currency && window.Intl && Intl.NumberFormat) {
      try {
        return new Intl.NumberFormat('en', { style: 'currency', currency: FUKUI.currency }).format((cents || 0) / 100);
      } catch (e) {}
    }
    var format = FUKUI.moneyFormat || '€{{amount}}';
    var value = '';
    var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var placeholder = match ? match[1] : 'amount';
    function delimit(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands || ',';
      decimal = decimal || '.';
      var negative = number < 0 ? '-' : '';
      number = Math.abs(number || 0);
      var fixed = (number / 100).toFixed(precision);
      var parts = fixed.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
      var centsPart = parts[1] ? decimal + parts[1] : '';
      return negative + dollars + centsPart;
    }
    switch (placeholder) {
      case 'amount': value = delimit(cents, 2); break;
      case 'amount_no_decimals': value = delimit(cents, 0); break;
      case 'amount_with_comma_separator': value = delimit(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = delimit(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = delimit(cents, 2, "'", '.'); break;
      default: value = delimit(cents, 2);
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, value);
  };

  /* ── toast ─────────────────────────────────── */
  var toastEl = null, toastT;
  FUKUI.toast = function (msg) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    toastEl.classList.add('on');
    clearTimeout(toastT);
    toastT = setTimeout(function () { toastEl.classList.remove('on'); }, 2600);
  };

  document.addEventListener('DOMContentLoaded', function () {

    /* ── announcement marquee: duplicate content for a seamless loop ── */
    var marq = document.getElementById('marq');
    if (marq) marq.innerHTML += marq.innerHTML;

    /* ── sticky header border on scroll ── */
    var hdr = document.getElementById('hdr');
    if (hdr) {
      var onScroll = function () { hdr.classList.toggle('scrolled', window.scrollY > 8); };
      addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }

    /* ── 井 grid toggle (persisted) ── */
    var gb = document.getElementById('gridBtn');
    try { if (localStorage.getItem('fukui-grid-off') === '1') document.body.classList.add('grid-off'); } catch (e) {}
    if (gb) {
      gb.setAttribute('aria-pressed', String(!document.body.classList.contains('grid-off')));
      gb.classList.toggle('off', document.body.classList.contains('grid-off'));
      gb.addEventListener('click', function () {
        var off = document.body.classList.toggle('grid-off');
        gb.setAttribute('aria-pressed', String(!off));
        gb.classList.toggle('off', off);
        try { localStorage.setItem('fukui-grid-off', off ? '1' : '0'); } catch (e) {}
      });
    }

    /* ── mega menus (desktop) ── */
    var megas = Array.prototype.slice.call(document.querySelectorAll('.mega'));
    var navbtns = Array.prototype.slice.call(document.querySelectorAll('.navbtn'));
    var mShade = document.getElementById('megaShade');
    var openId = null, hoverT;
    function closeMega() {
      megas.forEach(function (m) { m.hidden = true; });
      navbtns.forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      if (mShade) mShade.hidden = true;
      openId = null;
    }
    function openMega(id) {
      closeMega();
      var m = document.getElementById(id);
      if (!m) return;
      m.hidden = false;
      if (mShade) mShade.hidden = false;
      openId = id;
      var btn = navbtns.filter(function (b) { return b.dataset.menu === id; })[0];
      if (btn) btn.setAttribute('aria-expanded', 'true');
    }
    navbtns.forEach(function (b) {
      b.addEventListener('click', function () { openId === b.dataset.menu ? closeMega() : openMega(b.dataset.menu); });
      b.addEventListener('mouseenter', function () { clearTimeout(hoverT); hoverT = setTimeout(function () { openMega(b.dataset.menu); }, 120); });
      b.addEventListener('mouseleave', function () { clearTimeout(hoverT); });
    });
    if (hdr) {
      hdr.addEventListener('mouseleave', function () { hoverT = setTimeout(closeMega, 250); });
      hdr.addEventListener('mouseenter', function () { clearTimeout(hoverT); });
    }
    if (mShade) mShade.addEventListener('click', closeMega);
    document.querySelectorAll('nav.main > a').forEach(function (a) { a.addEventListener('mouseenter', closeMega); });
    addEventListener('scroll', function () { if (openId) closeMega(); }, { passive: true });

    /* ── mobile drawer ── */
    var drawer = document.getElementById('drawer');
    var dShade = document.getElementById('drawerShade');
    var burger = document.getElementById('burger');
    function openDrawer() { if (!drawer) return; drawer.hidden = false; dShade.hidden = false; burger.setAttribute('aria-expanded', 'true'); document.body.style.overflow = 'hidden'; }
    function closeDrawer() { if (!drawer) return; drawer.hidden = true; dShade.hidden = true; burger.setAttribute('aria-expanded', 'false'); document.body.style.overflow = ''; }
    if (burger) burger.addEventListener('click', function () { drawer.hidden ? openDrawer() : closeDrawer(); });
    var dClose = document.getElementById('drawerClose');
    if (dClose) dClose.addEventListener('click', closeDrawer);
    if (dShade) dShade.addEventListener('click', closeDrawer);
    addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeMega(); closeDrawer(); FUKUI.cart.close(); } });
  });

  /* ── cart drawer (Shopify Cart AJAX API) ─────────────────── */
  FUKUI.cart = (function () {
    var state = null;
    var recs = null;          // cached recommendations, keyed by the product they were asked for
    var recsFor = null;
    var noteTimer;
    var lastFocus = null;   // whatever opened the drawer, so focus can go back

    function fetchCart() {
      return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) { state = c; return c; });
    }

    function money(cents) { return FUKUI.formatMoney(cents); }
    function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
    function thumb(url, size) { return url ? url.replace(/(\.[a-z]+)(\?|$)/, '_' + (size || 300) + 'x$1$2') : ''; }

    function lineHTML(item) {
      var img = item.image ? '<img src="' + thumb(item.image) + '" alt="">' : '';
      var variant = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
      var props = '';
      var madeToOrder = false;
      if (item.properties) {
        Object.keys(item.properties).forEach(function (k) {
          if (k.charAt(0) === '_' || !item.properties[k]) return;
          if (/configuration|made to order/i.test(k)) madeToOrder = true;
          props += (props || variant ? ' · ' : '') + k + ': ' + item.properties[k];
        });
      }
      var compare = item.original_line_price > item.final_line_price ? '<s>' + money(item.original_line_price) + '</s>' : '';
      /* with more than one of a piece the line total alone hides what one costs */
      var unit = item.quantity > 1 ? '<span class="unit">' + money(item.final_price) + ' each</span>' : '';
      var chip = madeToOrder ? '<span class="made">made to order</span>' : '';
      return '<div class="li" data-key="' + item.key + '">' +
        '<div class="ph"><a href="' + item.url + '">' + img + '</a></div>' +
        '<div><h4><a href="' + item.url + '">' + esc(item.product_title) + '</a></h4>' +
        '<span class="var">' + esc(variant + props) + '</span>' + chip +
        '<div class="qty"><button data-q="-1" aria-label="Decrease quantity">−</button><span>' + item.quantity + '</span><button data-q="1" aria-label="Increase quantity">+</button></div>' +
        '<a class="rm" href="#" data-rm>Remove</a></div>' +
        '<div class="pr">' + compare + money(item.final_line_price) + unit + '</div></div>';
    }

    /* Everything below the lines lives in the scrolling body, so the totals
       stay pinned to the foot however much of it there is. */
    function extrasHTML() {
      return '<div class="cd-recs" id="cdRecs"></div>' +
        '<details class="cd-block" id="cdNoteBlock">' +
          '<summary class="mono">add a note to this order</summary>' +
          '<textarea id="cdNote" rows="3" placeholder="Floor, door code, preferred delivery day…">' + esc(state.note || '') + '</textarea>' +
          '<span class="hint mono" id="cdNoteHint"></span>' +
        '</details>' +
        '<details class="cd-block" id="cdCodeBlock">' +
          '<summary class="mono">discount code</summary>' +
          '<div class="cd-code"><input id="cdCodeIn" placeholder="Enter code" aria-label="Discount code"><button type="button" id="cdCodeBtn">Apply</button></div>' +
          '<span class="hint mono" id="cdCodeHint" aria-live="polite"></span>' +
        '</details>';
    }

    /* Subtotal must be the price before discounts, or the arithmetic on screen
       does not add up: Shopify's items_subtotal_price is already discounted. */
    function totalsHTML() {
      var rows = '';
      var gross = state.original_total_price;
      rows += '<div class="cd-row"><span>Subtotal · ' + state.item_count + ' pcs</span><span>' + money(gross) + '</span></div>';

      var named = 0;
      (state.cart_level_discount_applications || []).forEach(function (d) {
        named += d.total_allocated_amount;
        rows += '<div class="cd-row disc"><span>' + esc(d.title) + '</span><span>−' + money(d.total_allocated_amount) + '</span></div>';
      });
      /* code discounts on collections land on the lines, not the cart —
         aggregate them per code so the row can carry the code's name */
      var lineNamed = {};
      (state.items || []).forEach(function (it) {
        (it.line_level_discount_allocations || []).forEach(function (a) {
          var t = (a.discount_application && a.discount_application.title) || 'Discount';
          lineNamed[t] = (lineNamed[t] || 0) + a.amount;
        });
      });
      Object.keys(lineNamed).forEach(function (t) {
        named += lineNamed[t];
        rows += '<div class="cd-row disc"><span>' + esc(t) + '</span><span>−' + money(lineNamed[t]) + '</span></div>';
      });
      var rest = (state.total_discount || 0) - named;
      if (rest > 0) rows += '<div class="cd-row disc"><span>Item discounts</span><span>−' + money(rest) + '</span></div>';

      rows += '<div class="cd-row"><span>Delivery</span><span>' + (FUKUI.strings && FUKUI.strings.cartDelivery || 'Free · EU &amp; UK') + '</span></div>';
      rows += '<div class="cd-row total"><span>Total</span><span class="v">' + money(state.total_price) + '</span></div>';
      return rows;
    }

    function mount() {
      if (document.getElementById('cdrawer')) return;
      var d = document.createElement('div');
      d.className = 'cdrawer'; d.id = 'cdrawer'; d.hidden = true;
      d.setAttribute('aria-label', 'Cart');
      d.setAttribute('role', 'dialog');
      d.setAttribute('aria-modal', 'true');
      d.tabIndex = -1;
      d.innerHTML = '<div class="cd-top"><span class="mono"><strong id="cdCount">0</strong> · Cart</span><button class="ico" id="cdClose" aria-label="Close">✕</button></div>' +
        '<div class="cd-body" id="cdBody"></div><div class="cd-foot" id="cdFoot"></div>';
      var s = document.createElement('div');
      s.className = 'cshade'; s.id = 'cshade'; s.hidden = true;
      s.setAttribute('aria-hidden', 'true');
      document.body.appendChild(s); document.body.appendChild(d);
      document.getElementById('cdClose').addEventListener('click', close);
      s.addEventListener('click', close);

      /* an overlay you can tab out of is not an overlay; keep the ring inside */
      document.addEventListener('keydown', function (e) {
        if (e.key !== 'Tab' || d.hidden) return;
        var f = Array.prototype.slice.call(d.querySelectorAll(
          'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),summary,[tabindex]:not([tabindex="-1"])'
        )).filter(function (n) { return n.offsetWidth || n.offsetHeight || n === document.activeElement; });
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
        else if (!d.contains(document.activeElement)) { e.preventDefault(); first.focus(); }
      }, true);

      document.getElementById('cdBody').addEventListener('click', function (e) {
        var q = e.target.closest('[data-q]');
        var rm = e.target.closest('[data-rm]');
        var addBtn = e.target.closest('[data-add]');
        if (q) {
          var li = q.closest('.li');
          var item = state.items.filter(function (i) { return i.key === li.dataset.key; })[0];
          change(li.dataset.key, item.quantity + parseInt(q.dataset.q, 10));
        }
        if (rm) { e.preventDefault(); change(rm.closest('.li').dataset.key, 0); }
        if (addBtn && addBtn.dataset.add) {
          addBtn.disabled = true;
          add({ id: parseInt(addBtn.dataset.add, 10), quantity: 1 })
            .catch(function () { addBtn.disabled = false; FUKUI.toast('Could not add that piece.'); });
        }
      });

      /* the note saves itself a moment after you stop typing */
      document.getElementById('cdBody').addEventListener('input', function (e) {
        if (e.target.id !== 'cdNote') return;
        var hint = document.getElementById('cdNoteHint');
        clearTimeout(noteTimer);
        noteTimer = setTimeout(function () {
          fetch('/cart/update.js', {
            method: 'POST', credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ note: e.target.value })
          }).then(function (r) { return r.json(); }).then(function (c) {
            state = c;
            if (hint) { hint.textContent = 'saved'; setTimeout(function () { hint.textContent = ''; }, 1800); }
          });
        }, 700);
      });

      document.getElementById('cdBody').addEventListener('keydown', function (e) {
        if (e.target.id === 'cdCodeIn' && e.key === 'Enter') { e.preventDefault(); applyCode(); }
      });
      document.getElementById('cdBody').addEventListener('click', function (e) {
        if (e.target.id === 'cdCodeBtn') applyCode();
      });
    }

    function applyCode() {
      var input = document.getElementById('cdCodeIn');
      var btn = document.getElementById('cdCodeBtn');
      if (!input) return;
      var code = input.value.trim();
      if (!code) { input.focus(); return; }
      if (btn) { btn.disabled = true; btn.textContent = '…'; }

      /* Fetching /discount/CODE attaches the code to the session exactly the
         way navigating there would, minus the navigation — the drawer stays
         open. The cart re-fetch then says whether the code changed anything:
         a discount row appears in the totals and the hint names the saving.
         A code the cart cannot show (checkout-only, or simply wrong) gets an
         honest "checked at checkout" instead of a false success. */
      var before = state ? (state.total_discount || 0) : 0;
      fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin' })
        .then(function () { return fetchCart(); })
        .then(function () {
          badge(); render();
          var after = state ? (state.total_discount || 0) : 0;
          /* the cart itself says whether the code is any good */
          var entry = null;
          (state && state.discount_codes || []).forEach(function (d) {
            if (String(d.code).toLowerCase() === code.toLowerCase()) entry = d;
          });

          /* render() rebuilt the block closed and blank — reopen it to answer */
          var block = document.getElementById('cdCodeBlock');
          if (block) block.open = true;
          var hint = document.getElementById('cdCodeHint');
          var input2 = document.getElementById('cdCodeIn');
          if (entry && entry.applicable) {
            /* the saving comes from the cart's own allocations, so the amount
               is right even when the code was already on the cart */
            var amt = 0;
            (state.cart_level_discount_applications || []).forEach(function (d) {
              if (String(d.title).toLowerCase() === code.toLowerCase()) amt += d.total_allocated_amount;
            });
            (state.items || []).forEach(function (it) {
              (it.line_level_discount_allocations || []).forEach(function (a) {
                var t = a.discount_application && a.discount_application.title;
                if (t && String(t).toLowerCase() === code.toLowerCase()) amt += a.amount;
              });
            });
            if (hint) hint.textContent = amt > 0
              ? code.toUpperCase() + ' applied · −' + money(amt)
              : code.toUpperCase() + ' applied — you\'ll see it at checkout.';
          } else if (entry) {
            if (input2) { input2.value = code; input2.focus(); }
            if (hint) hint.textContent = 'This code doesn\'t apply to your cart.';
          } else if (after > before) {
            if (hint) hint.textContent = code.toUpperCase() + ' applied · −' + money(after - before);
          } else {
            if (input2) { input2.value = code; input2.focus(); }
            if (hint) hint.textContent = 'Saved — it will be checked at checkout.';
          }
        })
        .catch(function () {
          var btn2 = document.getElementById('cdCodeBtn');
          if (btn2) { btn2.disabled = false; btn2.textContent = 'Apply'; }
          FUKUI.toast('Could not apply the code.');
        });
    }

    /* One or two pieces that go with what is already in the basket. Complementary
       products come from Search & Discovery; related is the fallback. */
    function loadRecs() {
      var wrap = document.getElementById('cdRecs');
      if (!wrap || !state || !state.items.length) return;
      var pid = state.items[0].product_id;
      var inCart = state.items.map(function (i) { return i.product_id; });

      function paint(products) {
        var picks = (products || []).filter(function (p) {
          return p.available && inCart.indexOf(p.id) < 0;
        }).slice(0, 2);
        if (!picks.length) { wrap.innerHTML = ''; return; }
        wrap.innerHTML = '<div class="cd-h mono">goes well together</div>' + picks.map(function (p) {
          var v = p.variants && p.variants[0] ? p.variants[0].id : '';
          var img = p.featured_image ? '<img src="' + thumb(p.featured_image, 200) + '" alt="">' : '';
          return '<div class="cd-rec">' +
            '<a class="ph" href="' + p.url + '">' + img + '</a>' +
            '<div><h5><a href="' + p.url + '">' + esc(p.title) + '</a></h5>' +
            '<span class="mono">' + money(p.price) + '</span></div>' +
            '<button class="mini" type="button" data-add="' + v + '">Add</button>' +
            '</div>';
        }).join('');
      }

      if (recsFor === pid && recs) { paint(recs); return; }
      var url = function (intent) { return '/recommendations/products.json?product_id=' + pid + '&limit=6&intent=' + intent; };
      fetch(url('complementary'), { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (d) {
          if (d.products && d.products.length) return d.products;
          return fetch(url('related'), { credentials: 'same-origin' })
            .then(function (r) { return r.json(); })
            .then(function (d2) { return d2.products || []; });
        })
        .then(function (products) { recs = products; recsFor = pid; paint(products); })
        .catch(function () { wrap.innerHTML = ''; });
    }

    function render() {
      var body = document.getElementById('cdBody'), foot = document.getElementById('cdFoot');
      if (!body || !state) return;
      document.getElementById('cdCount').textContent = state.item_count;

      if (!state.items.length) {
        body.innerHTML = '<div class="cd-empty"><b>Your cart is empty.</b>The register is one click away.<br><br><a class="btn" href="' + (FUKUI.routes && FUKUI.routes.all_products || '/collections/all') + '">Browse the catalog →</a></div>';
        foot.innerHTML = '';
        return;
      }

      body.innerHTML = state.items.map(lineHTML).join('') + extrasHTML();
      foot.innerHTML = totalsHTML() +
        '<div class="cd-fine mono">' + (FUKUI.strings && FUKUI.strings.taxNote || 'incl. VAT · shipping calculated at checkout') + '</div>' +
        '<div class="cd-fine mono">' + (FUKUI.strings && FUKUI.strings.cartDispatch || 'ships in 2–3 business days · insured &amp; tracked') + '</div>' +
        '<a class="btn" href="' + (FUKUI.routes && FUKUI.routes.cart || '/cart') + '" style="margin-top:14px">Go to cart · ' + money(state.total_price) + '</a>' +
        '<a class="cont" href="#" id="cdCont">Continue shopping</a>' +
        '<div class="cd-trust mono"><span>30-day returns</span><span>2-year warranty</span><span>secure checkout</span></div>';

      var cc = document.getElementById('cdCont');
      if (cc) cc.addEventListener('click', function (e) { e.preventDefault(); close(); });
      loadRecs();
    }

    function badge() {
      var n = document.querySelector('.cart .n');
      if (n && state) n.textContent = state.item_count;
    }

    function change(key, qty) {
      return fetch('/cart/change.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(function (r) { return r.json(); }).then(function (c) {
        state = c; badge(); render();
        document.dispatchEvent(new CustomEvent('fukui:cart:change', { detail: c }));
        return c;
      });
    }

    function add(items) {
      var payload = Array.isArray(items) ? { items: items } : { items: [items] };
      return fetch('/cart/add.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      }).then(function (r) {
        if (!r.ok) return r.json().then(function (e) { throw e; });
        return r.json();
      }).then(function () {
        return fetchCart().then(function () { badge(); open(); });
      });
    }

    function open() {
      mount();
      if (!document.getElementById('cdrawer').contains(document.activeElement)) lastFocus = document.activeElement;
      fetchCart().then(function () { render(); });
      var d = document.getElementById('cdrawer');
      d.hidden = false;
      document.getElementById('cshade').hidden = false;
      document.body.style.overflow = 'hidden';
      var closeBtn = document.getElementById('cdClose');
      if (closeBtn) closeBtn.focus();
    }
    function close() {
      var d = document.getElementById('cdrawer');
      if (!d) return;
      d.hidden = true;
      document.getElementById('cshade').hidden = true;
      document.body.style.overflow = '';
      /* back to whatever the shopper was on before the drawer took over */
      if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
      lastFocus = null;
    }

    document.addEventListener('DOMContentLoaded', function () {
      mount();
      fetchCart().then(badge);
      var cartLink = document.querySelector('a.cart');
      if (cartLink && !document.body.classList.contains('template-cart')) {
        cartLink.addEventListener('click', function (e) { e.preventDefault(); open(); });
      }
    });

    return { add: add, change: change, open: open, close: close, refresh: function () { return fetchCart().then(function (c) { badge(); render(); return c; }); }, state: function () { return state; } };
  })();
})();

/* ── visual polish: photos fade in, sections rise in ───────── */
(function () {
  'use strict';

  /* Only photos that are still loading get hidden, so nothing that has
     already painted ever flashes; without JS nothing is touched at all. */
  function watch(img) {
    if (img.complete || img.classList.contains('pi')) return;
    img.classList.add('pi');
    var done = function () { img.classList.add('ld'); };
    img.addEventListener('load', done, { once: true });
    img.addEventListener('error', done, { once: true });
  }
  function watchAll() {
    document.querySelectorAll('.ph img.photo:not(.alt)').forEach(watch);
  }
  watchAll();

  document.addEventListener('DOMContentLoaded', function () {
    /* filtering and ajax re-renders bring new photos; catch them quietly */
    var t;
    new MutationObserver(function () {
      clearTimeout(t); t = setTimeout(watchAll, 120);
    }).observe(document.body, { childList: true, subtree: true });

    /* Sections rise in as they come up the page — once. A scroll sweep
       instead of IntersectionObserver: an observer never fires for pieces
       jumped straight past (anchors, fast wheel, find-in-page), which left
       permanent holes; the sweep reveals everything at or above the fold,
       however it got there. Whatever is on screen at load stays put. */
    if (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (window.Shopify && Shopify.designMode) return;
    var sel = '.reg-head, .facts > div, .cols > div, .cats > a, .trust > div, ' +
              '.reviews .grid > .r, .journal .list > a, #grid > *, .track > .card, .xsell > div';
    var main = document.getElementById('MainContent') || document.body;
    var els = [];
    document.querySelectorAll(sel).forEach(function (el) {
      if (!main.contains(el)) return;                      /* keep out of the header's hidden menus */
      if (!el.offsetWidth && !el.offsetHeight) return;     /* invisible — nothing to stage */
      if (el.getBoundingClientRect().top < innerHeight * 0.92) return;
      var sib = 0, n = el;
      while ((n = n.previousElementSibling) && sib < 3) sib++;
      el.style.setProperty('--rvd', (sib * 70) + 'ms');
      el.classList.add('fx-rv');
      els.push(el);
    });
    if (!els.length) return;
    var ticking = false;
    function sweep() {
      els = els.filter(function (el) {
        if (el.getBoundingClientRect().top < innerHeight * 0.96) { el.classList.add('fx-in'); return false; }
        return true;
      });
      if (!els.length) { removeEventListener('scroll', onScroll); removeEventListener('resize', onScroll); }
    }
    /* leading + trailing call, no rAF: rAF pauses in hidden tabs, and a page
       restored from a background tab must still have revealed correctly */
    function onScroll() {
      if (ticking) return;
      ticking = true;
      sweep();
      setTimeout(function () { ticking = false; sweep(); }, 90);
    }
    addEventListener('scroll', onScroll, { passive: true });
    addEventListener('resize', onScroll);
    sweep();
  });
})();

/* ── back to top ───────────────────────────────── */
(function () {
  'use strict';
  document.addEventListener('DOMContentLoaded', function () {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'totop';
    b.setAttribute('aria-label', 'Back to top');
    b.textContent = '↑';
    document.body.appendChild(b);
    b.addEventListener('click', function () {
      var smooth = !(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches);
      window.scrollTo({ top: 0, behavior: smooth ? 'smooth' : 'auto' });
    });
    /* shows only once the page is a screen deep — no button on short pages */
    var vis = false;
    function check() {
      var on = scrollY > innerHeight * 1.2;
      if (on !== vis) { vis = on; b.classList.toggle('on', on); }
    }
    addEventListener('scroll', check, { passive: true });
    check();
  });
})();

/* ── wishlist ───────────────────────────────────── */
(function () {
  'use strict';
  var KEY = 'fukui-wishlist';
  var W = window.FUKUI.wish = {
    all: function () { try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; } },
    has: function (h) { return W.all().indexOf(h) !== -1; },
    remove: function (h) { var a = W.all(); var i = a.indexOf(h); if (i > -1) { a.splice(i, 1); W.save(a); } },
    toggle: function (h) {
      var a = W.all(); var i = a.indexOf(h);
      if (i === -1) { a.push(h); window.FUKUI.toast('Saved to your wishlist'); }
      else { a.splice(i, 1); window.FUKUI.toast('Removed from your wishlist'); }
      W.save(a); return i === -1;
    },
    save: function (a) { try { localStorage.setItem(KEY, JSON.stringify(a)); } catch (e) {} badge(); }
  };
  function badge() {
    var n = document.querySelector('#wishBtn .n');
    if (n) { var c = W.all().length; n.textContent = c; n.hidden = !c; }
  }
  /* paint every heart to match the stored state — also after ajax re-renders */
  function mark() {
    document.querySelectorAll('[data-wish]').forEach(function (b) {
      var on = W.has(b.dataset.wish);
      b.classList.toggle('on', on);
      b.setAttribute('aria-pressed', String(on));
    });
  }
  document.addEventListener('DOMContentLoaded', function () {
    badge(); mark();
    var t;
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(mark, 150); })
      .observe(document.body, { childList: true, subtree: true });
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-wish]');
      if (!b) return;
      e.preventDefault(); e.stopPropagation();
      var on = W.toggle(b.dataset.wish);
      document.querySelectorAll('[data-wish="' + b.dataset.wish + '"]').forEach(function (x) {
        x.classList.toggle('on', on);
        x.setAttribute('aria-pressed', String(on));
      });
    }, true);
  });
})();
